import type { OnboardingDataItem } from "@configs/custom-app-config-schema";
import Icon from "@expo/vector-icons/MaterialIcons";
import { useAppStore } from "@hooks/useAppStore";
import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import { useTranslation } from "react-i18next";
import { List, RadioButton } from "react-native-paper";

const Goal = ({
	goals,
	selectedGoal,
	onSelectGoal,
}: {
	goals: OnboardingDataItem[];
	selectedGoal: OnboardingDataItem | undefined;
	onSelectGoal: (goal: OnboardingDataItem) => void;
}) => {
	const theme = useAppTheme();
	const appFont = useAppStore((app) => app.app.font);
	const { t } = useTranslation();

	return (
		<Box gap={12}>
			{goals.map((goal) => (
				<List.Item
					key={goal.label}
					style={{
						// borderWidth: selectedGoal === goal.id ? 2 : 1,
						borderWidth: 1,
						borderColor:
							selectedGoal?.id === goal.id
								? theme.colors.primary
								: theme.colors.surfaceVariant,
						padding: 16,
						backgroundColor:
							selectedGoal?.id === goal.id
								? theme.colors.primaryContainer
								: "transparent",
					}}
					contentStyle={{ gap: 2 }}
					left={() => (
						<Box
							style={{
								borderWidth: 1,
								borderColor: theme.colors.surfaceVariant,
								width: 32,
								height: 32,
								justifyContent: "center",
								alignItems: "center",
								backgroundColor:
									selectedGoal?.id === goal.id
										? theme.colors.primary
										: "transparent",
							}}
						>
							<Icon
								name={goal.icon as never}
								size={16}
								color={
									selectedGoal?.id === goal.id
										? theme.colors.onPrimary
										: theme.palette.text.primary
								}
							/>
						</Box>
					)}
					title={t(goal.label!)}
					titleStyle={{ fontFamily: `${appFont}-semibold` }}
					description={t(goal.description!)}
					onPress={() => onSelectGoal(goal)}
					right={() => (
						<Box
							style={{ opacity: selectedGoal?.id === goal.id ? 1 : 0 }}
							justifyContent="center"
						>
							<RadioButton.Android
								value={goal.id!}
								status="checked"
								onPress={() => onSelectGoal(goal)}
							/>
						</Box>
					)}
				/>
			))}
		</Box>
	);
};

export default Goal;
